const arquivar_relatorio_final_da_escola = [
  {
    path: "/arquivar-relatorio-final-da-escola",
    name: "arquivar_relatorio_final_da_escola",
    meta: {
      allowedPermissions: ["relatoriofinal_arquivar", "relatoriofinal_buscar"],
      breadCrumb:
        "Processo de Resultado Final - Arquivar Relatório Final da Escola",
    },
    component: () =>
      import(
        "@/views/ArquivarRelatorioFinalDaEscola/ArquivarRelatorioFinalDaEscola.vue"
      ),
  },
];

export { arquivar_relatorio_final_da_escola };
